import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import { TableHead } from './table';

export function SortableTableHeader({ 
  children, 
  column, 
  sortBy, 
  sortOrder, 
  onSort, 
  className = '' 
}) {
  const isActive = sortBy === column;
  
  const handleClick = () => {
    if (isActive) {
      onSort(column, sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      onSort(column, 'asc');
    }
  };

  return (
    <TableHead 
      className={`text-[10px] font-bold uppercase tracking-wider text-slate-500 cursor-pointer hover:bg-slate-100 select-none transition-colors ${className}`}
      onClick={handleClick}
    >
      <div className="flex items-center gap-1">
        {children}
        {isActive ? (
          sortOrder === 'asc' ? (
            <ArrowUp size={12} className="text-orange-500" />
          ) : (
            <ArrowDown size={12} className="text-orange-500" />
          )
        ) : (
          <ArrowUpDown size={12} className="text-slate-300" />
        )}
      </div>
    </TableHead>
  );
}
